import { memo } from 'react';
import { TECH_CAROUSEL } from '@/src/constants';

function TechCarousel() {
  // Render 4 sets for seamless loop
  const items = [...TECH_CAROUSEL, ...TECH_CAROUSEL, ...TECH_CAROUSEL, ...TECH_CAROUSEL];

  return (
    <section className="w-full border-y border-white/5 bg-black/50 py-10 overflow-hidden relative">
      {/* Fade edges */}
      <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#050505] to-transparent z-10 pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#050505] to-transparent z-10 pointer-events-none" />

      {/* Wrapper for GPU optimization */}
      <div className="will-change-transform">
        <div
          className="flex gap-16 md:gap-32 animate-[scroll_40s_linear_infinite] w-max items-center"
          style={{ transformStyle: 'preserve-3d' }}
        >
          {items.map((tech, i) => (
            <div
              key={i}
              className="text-xl md:text-2xl font-bold text-gray-600 uppercase tracking-widest hover:text-white transition-colors cursor-default select-none transform translate-z-0"
            >
              {tech}
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes scroll {
          0% { transform: translate3d(0, 0, 0); }
          100% { transform: translate3d(-25%, 0, 0); }
        }
      `}</style>
    </section>
  );
}

export default memo(TechCarousel);
